import * as types from './actionTypes';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  loading: false,
  open: false,
  openPreview: false,
  eateries : [],
  cities: [],
  current: {},
  listicle: {}
});

export default function reduce(state = initialState, action = {}) {
  switch (action.type) {
    case types.LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.LOADED:
      return {
        ...state,
        loading: false,
        eateries: action.eateries,
        cities: action.cities,
        current: action.current,
        fileResp: action.fileResp,
        listicle: action.listicle
      };
    default:
      return state;
  }
}

//Selectors
export function getValue(state, key) {
  const value = state["addEditListicle"][key];
  switch (key) {
    default:
      return value;
  }
}

export function getAllValues(state, key) {
  return state["addEditListicle"];
}
